:host {
  /* Component styles go here */
  display: block;
  font-family: var(--primary-font);
  color: var(--color-nero);
  @include supportedTypography();

  align-items: center;
  overflow-wrap: break-word;
  --text-align: initial;

  z-index:0;
}

.heading {
  font-family: var(--primary-font);
  color: var(--color-nero);
  text-align: var(--text-align);
}

h1.heading, h2.heading  {
  font-weight: var(--font-weight-bold);
  margin: 0px;
}

.reset {
  font-size: inherit;
}

a {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: var(--color-nero);
  }
}

h3.heading, h4.heading, h5.heading, h6.heading {
  font-weight: var(--font-weight-semibold);
  margin: 0px;
}

h1.heading {
  @include setFontSizeWithDefaultLineHeightRatio(41px);
}

h2.heading {
  @include setFontSizeWithDefaultLineHeightRatio(26px);
}

// Common style for mobile / desktop
h3.heading {
  @include setFontSizeWithDefaultLineHeightRatio(20px);
}

h4.heading {
  @include setFontSizeWithDefaultLineHeightRatio(20px);
}

h5.heading {
  @include setFontSizeWithDefaultLineHeightRatio(18px);
}

h6.heading {
  @include setFontSizeWithDefaultLineHeightRatio(18px);
}

@include breakpointMin('lg') {
  h1.heading {
    @include setFontSizeWithDefaultLineHeightRatio(56px);

    &.size-8, &.lg-size-10 {
      @include setFontSizeWithDefaultLineHeightRatio(56px);
    }
  }

  h2.heading {
    @include setFontSizeWithDefaultLineHeightRatio(50px);
  }

  h3.heading {
    @include setFontSizeWithDefaultLineHeightRatio(24px);
  }

  h5.heading {
    @include setFontSizeWithDefaultLineHeightRatio(20px);
  }

}

@include supportedColors();

.tooltip {
  margin-top: .3125rem;
  margin-left: 1rem;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
